import React from "react";

function CezBanner({ image, eyebrow, title, subtitle }) {
  return (
    <section className="relative min-h-[42vh] lg:min-h-[52vh] flex items-end overflow-hidden text-white">
      <img src={image} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover object-center" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0b1f3f]/92 via-[#0b1f3f]/70 to-[#0b1f3f]/35" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0b1f3f]/85 via-transparent to-[#0b1f3f]/30" />
      <div className="relative w-full max-w-6xl mx-auto px-6 sm:px-10 lg:px-16 py-14 lg:py-20">
        {eyebrow && (
          <p className="text-xs sm:text-sm font-semibold uppercase tracking-[0.35em] text-amber-300 mb-4">
            {eyebrow}
          </p>
        )}
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight max-w-3xl">{title}</h1>
        {subtitle && (
          <p className="mt-5 text-lg sm:text-xl text-[#dbeafe] max-w-2xl font-medium leading-relaxed">{subtitle}</p>
        )}
      </div>
    </section>
  );
}

export default CezBanner;
